import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import gsap from "gsap";

// Pages
import HomePage from "./pages/HomePage";
import PageNotFound from "./pages/PageNotFound";
import MembersPage from "./pages/MembersPage";
import EventsPage from "./pages/EventsPage";
import ContactUs from "./pages/ContactUs";
import WinterOfCodeHomePage from "./components/WoC/home";
import HacktoberfestHomePage from "./components/Hacktoberfest/home";
import FaceOffHomePage from "./components/FaceOff/home";
import WinnersPage from "./pages/WinnersPage";

// Components
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import WinterOfCodeRegister from "./components/WoC/Register";
import HacktoberfestRegister from "./components/Hacktoberfest/Register";
import FaceOffRegister from "./components/FaceOff/Register";
import Snowfall from "./components/Snowfall";
import RegistrationIsOver from "./components/WoC/RegistrationIsOver";

// Material UI Styles
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

// CSS
import "./CSS/App.css";

function App() {
  const location = useLocation();

  const isSmallScreen = useMediaQuery("(max-width:600px)"); // `sm` in MUI is 600px

  const theme = createTheme({
    typography: {
      fontFamily: "Quicksand",
    },
  });

  const visiblePaths = [
    "/",
    "/events",
    "/members",
    "/contact-us",
    "/winners",
    "/events/winter-of-code",
    "/events/winter-of-code/register",
    "/events/hacktoberfest",
    // "/events/hacktoberfest/register",
    "/events/face-off",
    // "/events/face-off/register",
  ];

  const footerVisiblePaths = [
    "/",
    "/events",
    "/members",
    "/contact-us",
    "/events/winter-of-code",
    "/events/winter-of-code/register",
    "/events/hacktoberfest",
    // "/events/hacktoberfest/register",
    "/events/face-off",
    // "/events/face-off/register",
  ];

  const isVisiblePath = visiblePaths.includes(location.pathname);
  const isFooterVisiblePath = footerVisiblePaths.includes(location.pathname);

  // Get the current date in UTC
  const currentDate = new Date();
  const currentUTCDate = new Date(
    Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getUTCDate(),
      currentDate.getUTCHours(),
      currentDate.getUTCMinutes(),
      currentDate.getUTCSeconds()
    )
  );

  // Set the cutoff date in UTC (IST: 4 January 2025 00:00:00 => UTC: 3 January 2025 18:30:00)
  const cutoffUTCDate = new Date("2025-01-03T18:30:00Z");
  const isRegistrationOpen = currentUTCDate < cutoffUTCDate;

  useEffect(() => {
    const handleMouseMove = (e) => {
      console.log(e.clientX, e.clientY);
      gsap.to(".cursor", {
        x: e.x - 15,
        y: e.y - 80,
        duration: 0.2,
        ease: "power2.out",
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isVisiblePath && <NavBar />}
      <Snowfall color={"white"} />
      {!isSmallScreen ? (
        <div
          className="cursor"
          style={{
            position: "fixed",
            width: "40px",
            height: "40px",
            color: "red",
            backgroundColor: "white",
            borderRadius: "50%",
            zIndex: 9999,
            pointerEvents: "none",
            mixBlendMode: "difference",
            userSelect: "none",
          }}
        ></div>
      ) : null}
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/events" element={<EventsPage />} />
        <Route exact path="/members" element={<MembersPage />} />
        <Route exact path="/contact-us" element={<ContactUs />} />
        <Route exact path="/winners" element={<WinnersPage />} />
        <Route
          exact
          path="/events/winter-of-code"
          element={<WinterOfCodeHomePage />}
        />
        {/* Conditional rendering of the registration component */}
        <Route
          exact
          path="/events/winter-of-code/register"
          element={
            isRegistrationOpen ? (
              <WinterOfCodeRegister />
            ) : (
              <RegistrationIsOver />
            )
          }
        />
        <Route
          exact
          path="/events/hacktoberfest"
          element={<HacktoberfestHomePage />}
        />
        {/* <Route
          exact
          path="/events/hacktoberfest/register"
          element={<HacktoberfestRegister />}
        /> */}
        <Route exact path="/events/face-off" element={<FaceOffHomePage />} />
        {/* <Route
          exact
          path="/events/face-off/register"
          element={<FaceOffRegister />}
        /> */}
        <Route exact path="*" element={<PageNotFound />} />
      </Routes>
      {isFooterVisiblePath && <Footer />}
    </ThemeProvider>
  );
}

export default App;
